module.exports = __webpack_public_path__ + "img/partner-new-icon5.7bfc5a13.svg";